import { Currency, Form, Grid, Progress } from '@mairistem/composants';
import type { Tiers } from '@mairistem/comptabilite';
import { ceil } from 'lodash';
import React from 'react';

interface TiersFichePanelParametresGestionSecondaireProps {
	onChange?: (changes: Partial<Tiers>) => void;
	identifiant?: number | string;
	renseignementsDivers?: string;
	seuilAlerte?: number;
	seuilBlocage?: number;
}

const TiersFichePanelParametresGestionSecondaire = ({
	onChange,
	identifiant,
	seuilAlerte = null,
	seuilBlocage = null,
	renseignementsDivers,
}: TiersFichePanelParametresGestionSecondaireProps) => {
	const handleChange = React.useCallback(
		({ target }) => {
			const { name, value } = target || {};

			onChange?.({
				identifiant,
				[name]: value,
			});
		},
		[identifiant, onChange],
	);

	let value = 0;

	if (seuilAlerte !== 0 && seuilBlocage !== 0) {
		value = ceil((seuilAlerte / seuilBlocage) * 100, 2);

		if (value > 100) {
			value = 100;
		}
	}

	return (
		<Form>
			<Grid>
				<Grid.Row columns={2}>
					<Grid.Column>
						<Form.TextArea
							key="commentaire"
							label="Commentaire"
							name="renseignementsDivers"
							onChange={handleChange}
							placeholder="Informations complémentaires ..."
							value={renseignementsDivers}
						/>
					</Grid.Column>
					<Grid.Column>
						<Form.Group widths="equal">
							<Currency
								key="seuilAlerte"
								label="Seuil d'alerte"
								name="seuilAlerte"
								onChange={handleChange}
								value={seuilAlerte}
							/>
							<Currency
								key="seuilBlocage"
								label="Seuil de blocage"
								name="seuilBlocage"
								onChange={handleChange}
								value={seuilBlocage}
							/>
						</Form.Group>
						<Progress percent={value}>{`${value}%`}</Progress>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Form>
	);
};

export default TiersFichePanelParametresGestionSecondaire;
